/**
 * @see https://github.com/referenceable/referenceable_api/blob/develop/app/graphql/application/types/uploadable_type_enum.rb
 */
export enum UploadableType {
  ATTACHMENT = 'attachment',
  AUDIO = 'audio',
  DOCUMENT = 'document',
  IMAGE = 'image',
  SIGNABLE = 'signable',
  VIDEO = 'video',
}
